<template>

  <v-card loading elevation="24">
    <v-card-title class=" d-flex justify-center">

      <v-avatar size="150">
        <v-img @click="logout()" :src="user.avatar" />
      </v-avatar>
    </v-card-title>

    <v-card-text class="d-flex flex-column justify-center align-center">

      <v-subheader class="text-center text-h5">{{ user.name }}</v-subheader>

      <v-subheader class="text-center">Digite o valor de abertura</v-subheader>
      <MoneyInput v-model="initial_cash" ref="moneyInput" @keydown.enter="open" class="mx-auto" />
    </v-card-text>
    <v-card-actions v-if="$vuetify.breakpoint.xs">
      <v-btn @click="open" block color="success">Confirmar</v-btn>
    </v-card-actions>
  </v-card>

</template>

<script>
  import { mapActions, mapState } from "vuex";

  export default {
    data() {
      return {
        initial_cash: 0,
      };
    },

    computed: {
      ...mapState("auth", ["user"]),
      ...mapState("cashier", ["isOpenCashier"]),
      ...mapState("pos", ["pointOfSale", "pdv_id"]),
    },
    methods: {
      ...mapActions("auth", ["getUser", "logout"]),
      ...mapActions("cashier", ["activeCashier", "openCashier"]),

      open() {

        this.openCashier({
          initial_cash: this.initial_cash,
          pdv: this.pdv_id,
        }).then(() => {
          this.$toast.info("Caixa aberto com valor de abertura: R$" + this.initial_cash);
          this.initial_cash = 0;
          this.$emit("close-dialog");
        }).catch((error) => {
          if (error.response && error.response.status === 409 && error.response.data && error.response.data.message) {
            this.$toast.error(error.response.data.message);
          } else {
            this.$toast.error("Erro ao abrir o caixa: " + (error.message || ''));
          }
        });


      },
    },
    mounted() {

    },
  };
</script>
